import { Grid } from "@mui/material";
import { StyledComponentProps } from "@mui/styles";
import { FeedClassKey, GlobalClassKeys } from "assets/jss/common-styles";
import { PublicationType } from "models/ApiEnums";
import { PublicationAdminCourseDto } from "models/ApiModels";
import * as React from "react";
import AttachMetadataBox from "views/Publication/Components/AttachMetadataBox";
import CourseAdminPublisher from "views/Publication/Components/CourseAdminPublisher";
import RenderImage from "views/Publication/Components/RenderImage";
import BodyTextExpand from "views/Timeline/Components/CardComp/BodyTextExpand";
import { CardBodyData } from "views/Timeline/Components/CardLib/CardBodyData";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    /** Feed Item */
    data: PublicationAdminCourseDto;

    /** Exibir Publicador */
    showPublisher?: boolean;

    /** Evento ocorre quando o botão de expansão/contração é pressionado. */
    onTextExpandedChange?: (expanded: boolean) => void;
}

type Props = IProps & StyledComponentProps<FeedClassKey>;

/////////////////////////////////////////////////////////////////////////////////////

class CourseAdminBody extends React.PureComponent<Props> {

    private data: CardBodyData;

    constructor(props: Props) {
        super(props);

        this.state = { lighBoxOpen: false, lighBoxIndex: 0 };
    }

    static defaultProps = {
        showPublisher: true
    };

    private renderBody() {
        const {
            classes,
            showPublisher,
            data: { body }
        } = this.props;

        const expanded = this.data.textExpanded == null
            ? null  // Não haverá expansão pois "body == summary"
            : this.data.textExpanded;

        const showContent = body.summary != null || body.fullContent != null || body.fullContentLoaded === false;
        const rightPicture = this.data.getPictureUrl();
        const showRightPicture = rightPicture && !this.data.isLinkOnly() && !this.data.emptyContent() && !this.data.isVideo();

        return (
            <div className={classes.cardBody}>

                <Grid container wrap="nowrap" spacing={1}>

                    <Grid item className={GlobalClassKeys.grow}>
                        {
                            showPublisher &&
                            <CourseAdminPublisher {...this.props} />
                        }

                        {
                            showContent && !this.data.isLinkOnly() &&
                            <BodyTextExpand
                                classes={classes}
                                text={this.data.content}
                                expanded={expanded}
                                onTextExpandedChange={this.props.onTextExpandedChange}
                            />
                        }
                    </Grid>

                    {
                        showRightPicture &&
                        <Grid item>
                            <RenderImage
                                image={rightPicture.mainFile}
                                thumbnail={rightPicture.thumbnail ? rightPicture.thumbnail : null}
                                classes={this.props.classes}
                                alt="Course Thumbnail"
                            />
                        </Grid>
                    }

                </Grid>

                {
                    this.data.isVideo() &&
                    <AttachMetadataBox
                        fileOrLink={this.data.metadata || this.data.nonEmbedAttachs}
                        autoplay={false}
                    />
                }
            </div>
        );
    }

    render() {
        const { data: { body } } = this.props;

        this.data = new CardBodyData({
            body: body,
            bestAnswer: null,
            publicationType: PublicationType.Course
        }, false, false);

        return this.renderBody();
    }
}

export default CourseAdminBody;